import { render, staticRenderFns } from "./inventoryAge.vue?vue&type=template&id=85a43e10&scoped=true"
import script from "./inventoryAge.vue?vue&type=script&lang=js"
export * from "./inventoryAge.vue?vue&type=script&lang=js"
import style0 from "./inventoryAge.vue?vue&type=style&index=0&id=85a43e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a43e10",
  null
  
)

export default component.exports